function HostRights() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Host Rights</h1>
      </div>

      <div className="table-card">
        <p>Host Rights Management</p>
      </div>
    </div>
  );
}

export default HostRights;
